import styled from "styled-components";
import { AppBar as AppBarMaterialUI } from "@material-ui/core";
import { Toolbar } from "@material-ui/core";
import AnnounceKit from "announcekit-react";
import { Link } from "react-router-dom";

export const AppBar = styled(AppBarMaterialUI)`
  position: absolute;
  width: 100%;
  height: 60px;
  left: 0px;
  top: 0px;
  z-index: 1;

  background: var(--white);
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.06);

  .actions {
    width: 500px;
  }
`;

export const BarContainer = styled(Toolbar)`
  display: flex;
  justify-content: space-between;
`

export const CompanyName = styled.span`
  font-family: Ubuntu, sans-serif;
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 46px;
  letter-spacing: 0em;
  color: var(--secondary);
`;

export const Section = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  ${(props) => props.direction && `direction: ${props.direction};`}
`;

export const LinkNavBar = styled(Link)`
  color: var(--secondary);
  font-size: 18px;
`;

export const WhatsappStatus = styled.span`
  margin-left: 10px;
  font-size: 1.5em;
  line-height: 17px;
  color: ${({ whatsappOn }) => (whatsappOn ? "#16A257" : "#ED5565")};
`;

export const WidgetCountainer = styled.div`
  width: 150px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`
export const Widget = styled(AnnounceKit)`
 display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const WidgetSpan = styled.span`
  color: black;
  margin-left: 6px;
  text-transform: uppercase;
  font-weight: 500;
`;
